import actions from './actions.js';
import reducers from './reducers';

const redux = { reducers, actions };
export default redux;
